import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React from 'react'
import { parseIntOr } from '../../../../../common/utils/parseNumericInput'

function DailyTradeLimitField({ analyze, updateSetting }: { analyze: any; updateSetting: any }) {
  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel htmlFor="outlined-adornment-dailyTradeLimit">Daily trade limit</InputLabel>
        <OutlinedInput
          id="outlined-adornment-dailyTradeLimit"
          name="analyzeTrades.dailyTradeLimit"
          type="number"
          value={analyze.dailyTradeLimit === 0 ? '' : analyze.dailyTradeLimit}
          placeholder="∞"
          onChange={(e) =>
            // 0 is the "unlimited" sentinel, and what an empty box means.
            updateSetting('analyzeTrades.dailyTradeLimit', parseIntOr(e.target.value, 0))
          }
          inputProps={{ min: 0 }}
          startAdornment={<InputAdornment position="start">#</InputAdornment>}
          label="Daily trade limit"
        />
      </FormControl>
    </Grid>
  )
}

export default DailyTradeLimitField
